export default "__VITE_ASSET__CcKmJY1o__"